import React, { useEffect, useMemo, useState } from "react";
import { AgGauge } from "ag-charts-react";
import '../common/AgGrid/AgChartEnterprise.js';
import LoadingIndicator from "../common/loading_indicator.jsx";
import SeeAllButton from "../project_overview/components/SeeAllButton.jsx";
import {
  risk_management_monitoring_path,
  risk_management_data_path
} from '~/routes';
import ProjectCard from "../project_overview/components/ProjectCard.jsx";

const RiskGauge = ({risk_thresholds, risk_average_score = 0, risk_count = 0, displayTitle = false, project_id, context = null, settings}) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [thresholds, setThresholds] = useState(risk_thresholds);
  const [averageScore, setAverageScore] = useState(risk_average_score);
  const [riskCount, setRiskCount] = useState(risk_count);

  useEffect(() => {
    if (project_id) {
      jQuery.getJSON(risk_management_data_path({project_id: project_id, context: context}))
        .success((res) => {
          const {
            risk_matrix_risk_thresholds: thresholds,
            risk_average_score: avgScore,
            risk_count: count
          } = res;
          if (thresholds) {
            setThresholds(thresholds);
            setAverageScore(avgScore || 0);
            setRiskCount(count || 0);
          } else {
            setErrorMsg(I18n.t('invalid_data'));
          }
        });
    }
  }, [project_id, context]);

  const options = useMemo(() => {
    const maxThreshold = Math.max(...(thresholds || []).map(t => t.value)); 
    const sortedThresholds = (thresholds || []).sort((a, b) => a.value - b.value)
    
    const fills = sortedThresholds.map((t, i) => {
      return {
        color: t.color,
        stop: i === sortedThresholds.length - 1 ? 999 : sortedThresholds[i + 1].value
      };
    });

    return {
      type: "radial-gauge",
      value: averageScore,
      label: {
        enabled: true,
        formatter({ value }) {
          return value;
        },
      },
      scale: {
        min: 0,
        max: maxThreshold,
        label: {
          enabled: false,
        },
      },
      bar: {
        fills: fills,
        enabled: true,
        fillMode: "discrete",
      },
      needle: {
        enabled: true,
        strokeWidth: 3,
        radiusRatio: 0.95,
      },
    }
  }, [averageScore, thresholds])



  const renderGaugeContent = () => {
    if (errorMsg) return <div className='error-state'>{errorMsg}</div>;
    
    if ((!thresholds)) {
      return <LoadingIndicator />;
    }

    return (
      <>
        <div className='gauge-value'>
          <label>{averageScore.toFixed(1)}</label>
        </div>
        <AgGauge style={{ width: '100%', height: '80%' }} options={options} />
        <div className='gauge-description'>
          <label>{I18n.t('average_risk_score')}</label>
          {I18n.t('average_risk_count', { count: riskCount })}
        </div>
      </>
    );
  };

  return (
    <ProjectCard settings={settings}>
      {displayTitle && (
        <div className='card-title-container'>
          <h3>{I18n.t('risks')}</h3>
          <SeeAllButton link={risk_management_monitoring_path({ project_id })} />
        </div>
      )}

      <div className='gauge-container'>
        {renderGaugeContent()}
      </div>
    </ProjectCard>
  );
};

export default RiskGauge;